import { render, staticRenderFns } from "./MaskModel.vue?vue&type=template&id=68c5e096&scoped=true&"
import script from "./MaskModel.vue?vue&type=script&lang=js&"
export * from "./MaskModel.vue?vue&type=script&lang=js&"
import style0 from "./MaskModel.vue?vue&type=style&index=0&id=68c5e096&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c5e096",
  null
  
)

export default component.exports